import axiosInstance from './axiosInstance';

export const getUser = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;


    const response = await axiosInstance.get('/user', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getKyc = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/user/kyc', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStake = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/user/stake', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getKaitwallet = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/user/kait_wallet', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getincomewallet = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/user/income_wallet', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getroswallet = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/user/ros_wallet', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRestake = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/stake/api/stake/plan', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getstackreport = async (id) => {
  try {
    
    const response = await axiosInstance.get(`stake/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getuserreport = async (email) => {
  try {
    
    const response = await axiosInstance.get(`stake/api/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

function formatApiError(error, fallback = 'Failed to load report.') {
  if (error?.response?.data) {
    const data = error.response.data;
    const message = data.message || data.error || data.msg;
    if (message) return String(message);
  }
  if (error?.message) return error.message;
  return fallback;
}

async function fetchAllSearchResults(searchFn, queryParams) {
  const batchSize = 500;
  let currentPage = 1;
  let totalPages = 1;
  const allRows = [];

  do {
    const res = await searchFn({ ...queryParams, page: currentPage, limit: batchSize });
    const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
    allRows.push(...list);

    const pagination = res?.pagination ?? res?.data?.pagination;
    if (typeof pagination?.totalPages === 'number' && pagination.totalPages > 0) {
      totalPages = pagination.totalPages;
    } else if (typeof pagination?.totalRecords === 'number' && pagination.totalRecords >= 0) {
      totalPages = Math.max(1, Math.ceil(pagination.totalRecords / batchSize));
    } else if (list.length < batchSize) {
      totalPages = currentPage;
    } else {
      totalPages = currentPage + 1;
    }

    currentPage += 1;
  } while (currentPage <= totalPages);

  return allRows;
}

export const getnewuserreport = async (queryParams = {}) => {
  try {
    const normalized = typeof queryParams === 'string' ? { email: queryParams } : queryParams ?? {};
    const email = normalized.email?.trim() || '';
    const description = normalized.description?.trim() || '';

    if (email) {
      const params = { email };
      if (description) params.description = description;
      const response = await axiosInstance.get('stake/new/api', { params });
      const data = response.data;
      if (data?.status === false) {
        throw new Error(data.message || 'User not found');
      }
      return data;
    }

    if (description) {
      const [incomeWalletRows, fixedRosWalletRows] = await Promise.all([
        fetchAllSearchResults(getSearchIncome, { description }),
        fetchAllSearchResults(getSearchRos, { description })
      ]);

      return {
        status: true,
        message: 'Description search results',
        data: {
          income_wallet: incomeWalletRows,
          fixed_ros_wallet: fixedRosWalletRows,
          stake: [],
          restake: [],
          Withdrawals: [],
          Count: {
            stackCount: 0,
            RestackCount: 0,
            withdrawCount: 0,
            IncomeCount: incomeWalletRows.length,
            Roswallet: fixedRosWalletRows.length
          }
        }
      };
    }

    throw new Error('Please enter email and/or description.');
  } catch (error) {
    throw new Error(formatApiError(error));
  }
};

export const getolduserreport = async (email) => {
  try {
    const response = await axiosInstance.get(`stake/api/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getoveralluserreport = async (email) => {
  try {
    const response = await axiosInstance.get(`stake/api/users/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postLogin = async (email, password) => {
  try {
    // Sending data as an object: { email: email, password: password }
    const response = await axiosInstance.post('/login', { email, password });

    // Return the specific data (usually contains token and user info)
    return response.data;
  } catch (error) {
    // Optional: Extract the specific server message if it exists
    const message = error.response?.data?.message || 'Login failed';
    throw new Error(message);
  }
};

/**
 * Converts permissions object to backend-compatible format.
 * Output: array of strings e.g. ["users_read", "complaint_write", "ticket_read"]
 * Backend schema: permissions: [String] or permissions: { type: [String] }
 */
export const formatPermissionsForApi = (permissions = {}) => {
  const list = [];
  const keys = Object.keys(permissions);
  for (const key of keys) {
    const perm = permissions[key];
    if (perm && typeof perm === 'object') {
      if (perm.read) list.push(`${key}_read`);
      if (perm.write) list.push(`${key}_write`);
    }
  }
  return list;
};

// api/authApi.js
export const postRegister = async (userData) => {
  try {
    const response = await axiosInstance.post('/register', userData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response.data; // { success, message, token, user }
  } catch (error) {
    if (error.response) {
      const data = error.response.data || {};
      const status = error.response.status;

      // Extract message from various backend error shapes
      let message = data.message || data.error || data.msg;
      if (!message && data.errors) {
        const errList = Array.isArray(data.errors) ? data.errors : Object.values(data.errors);
        message = errList.map((e) => (typeof e === 'string' ? e : e?.message || e?.msg)).filter(Boolean).join('; ');
      }
      if (!message && status === 500) {
        message = 'Server error. Check backend logs or try again.';
      }

      throw new Error(message || 'Registration failed');
    }
    if (error.request) {
      throw new Error('Server not responding');
    }
    throw new Error(error.message || 'Something went wrong');
  }
};

export const postComplaint = async (complaintData) => {
  try {
    const response = await axiosInstance.post('/complaint', complaintData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getComplaint = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get('/complaint', {
      params: {
        page,
        limit
      }
    });

    return response.data;
  } catch (error) {
    console.error('Get Complaint Error:', error);
    throw (
      error.response?.data || {
        status: false,
        message: error.message
      }
    );
  }
};

// import complaint
export const postComplaintImport = async (file) => {
  const formData = new FormData();
  formData.append('file', file); // key name MUST match what backend's multer expects, e.g. upload.single('file')

  try {
    const response = await axiosInstance.post('/complaint/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updateComplaintById = async (id, complaintData) => {
  try {
    const response = await axiosInstance.put(`/complaint/${id}`, complaintData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteComplaint = async (id) => {
  try {
    // 1. Use the .delete method
    // 2. Pass the ID directly into the URL string
    const response = await axiosInstance.delete(`/complaint/${id}`);
    
    return response.data;
  } catch (error) {
    console.error("Failed to delete complaint:", error);
    throw error;
  }
};

export const getTickets = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get('/complaint/ticket', {
      params: { page, limit }
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// tickect_id message show
export const getTicketMessage = async (id, queryParams) => {
  try {
    const response = await axiosInstance.get(`/complaint/ticket_message/${id}`, {
      params: queryParams
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
  
// single ticket messsage post 
export const postTicketMessage = async (ticketId, messageData) => {
  try {
    const response = await axiosInstance.post(
      `/complaint/ticket/${ticketId}`,
      messageData 
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};


export const getAdmin = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/admin', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const getAdminById = async (id) => {
//   try {
//     const response = await axiosInstance.get(`/admin/${id}`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const updateAdminById = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/admin/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const deleteAdmin = async (id) => {
  try {
    // 1. Use the .delete method
    // 2. Pass the ID directly into the URL string
    const response = await axiosInstance.delete(`/admin/${id}`);
    
    return response.data;
  } catch (error) {
    console.error("Failed to delete admin:", error);
    throw error;
  }
};


export const postWithdraw = async (withdrawData) => {
  try {
    const response = await axiosInstance.post('/withdraw', withdrawData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWithdraw = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/withdraw/report', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
  
};

export const postLevelincome = async (levelincomeData) => {
  try {
    const response = await axiosInstance.post('/levelincome', levelincomeData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLevelincome = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/levelincome/report', { params });
    return response.data;  
  } catch (error) {
    throw error;
  }
};

export const postTransaction = async (TransactionData) => {
  try {
    const response = await axiosInstance.post('/transaction', TransactionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTransaction = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/transaction/report', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// adminApi.js
export const getTransactionSearch = async ({ page, limit, email, description }) => {
  try {
    // URLSearchParams guarantees '+' is encoded as '%2B' (not a space)
    const params = new URLSearchParams();
    
    if (typeof page === 'number') params.append('page', page);
    if (typeof limit === 'number') params.append('limit', limit);
    
    if (email && typeof email === 'string') {
      params.append('email', email.trim());
    }
    
    if (description && typeof description === 'string') {
      // Remove ALL spaces before sending to backend
      params.append('description', description.trim().replace(/\s+/g, ''));
    }

    // ✅ PASS AS STRING (with ?) to prevent Axios from messing up the + sign
    const response = await axiosInstance.get(`/transaction/search?${params.toString()}`);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const postStackOverall = async (StackOverallData) => {
  try {
    const response = await axiosInstance.post('/stake/report', StackOverallData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStackOverall = async (page, limit) => {
  try {
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/stake/overall/report', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOldUsers = async (page, limit) => {
  try {
    
    const params = {};
    if (typeof page === 'number') params.page = page;
    if (typeof limit === 'number') params.limit = limit;

    const response = await axiosInstance.get('/user/old_user', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getoldusers = (page, limit) => getOldUsers(page, limit);


export const getOldUsersEmail = async (email) => {
  try {
    const response = await axiosInstance.get(`/user/old_users/${encodeURIComponent(email)}`);
     console.log(response);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getSearchIncome = async (queryParams = {}) => {
  try {
    const params = {};
    if (queryParams.email?.trim()) params.email = queryParams.email.trim();
    if (queryParams.description?.trim()) params.description = queryParams.description.trim();
    if (typeof queryParams.page === 'number') params.page = queryParams.page;
    if (typeof queryParams.limit === 'number') params.limit = queryParams.limit;

    const response = await axiosInstance.get('/user/search/income', { params });
    return response.data;
  } catch (error) {
    console.error('API Error in getSearchIncome:', error.response?.data || error.message);
    throw error;
  }
};


export const getSearchRos = async (queryParams = {}) => {
  try {
    const params = {};
    if (queryParams.email?.trim()) params.email = queryParams.email.trim();
    if (queryParams.description?.trim()) params.description = queryParams.description.trim();
    if (typeof queryParams.page === 'number') params.page = queryParams.page;
    if (typeof queryParams.limit === 'number') params.limit = queryParams.limit;

    const response = await axiosInstance.get('/user/search/roswallet', { params });
    return response.data;
  } catch (error) {
    console.error('API Error in getSearchRos:', error.response?.data || error.message);
    throw error;
  }
};

export const getSearchkait = async (queryParams = {}) => {
  try {
    const params = {};
    if (queryParams.email?.trim()) params.email = queryParams.email.trim();
    if (queryParams.description?.trim()) params.description = queryParams.description.trim();
    if (typeof queryParams.page === 'number') params.page = queryParams.page;
    if (typeof queryParams.limit === 'number') params.limit = queryParams.limit;

    const response = await axiosInstance.get('/user/search/kaitwallet', { params });
    return response.data;
  } catch (error) {
    console.error('API Error in getSearchkait:', error.response?.data || error.message);
    throw error;
  }
};


export const getSearchDescription = async (queryParams = {}) => {
  try {
    const params = {};

    if (queryParams.description?.trim()) {
      // Do not wrap in asterisks (*). Send the plain string to avoid Regex crashes on the backend.
      params.description = queryParams.description.trim();
    }

    if (typeof queryParams.page === 'number') params.page = queryParams.page;
    if (typeof queryParams.limit === 'number') params.limit = queryParams.limit;

    const response = await axiosInstance.get('/user/search', { params });
    return response.data;
  } catch (error) {
    console.error('API Error in getSearchDescription:', error.response?.data || error.message);
    throw error;
  }
};


// maturity

// export const getmaturity = async (page, limit) => {
//   try {
//     const params = {};
//     if (typeof page === 'number') params.page = page;
//     if (typeof limit === 'number') params.limit = limit;

//     const response = await axiosInstance.get('/maturity/total/maturity', { params });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getmaturity = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/maturity/total/maturity', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
 

// email filter format
export const getemailfilter = async (email) => {
  try {
    
    const response = await axiosInstance.get(`maturity/api/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// withdraw transaction aprovel
export const WithdrawTransaction = async (WithdrawAmountData) => {
  try {
    const response = await axiosInstance.post('/withdraw/aprovel', WithdrawAmountData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// withdrawTransaction Email filter aprovel
export const WithdrawTransactionEmail = async (email) => {
  try {
    const response = await axiosInstance.get(`withdraw/aprovel/${email}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};



// withdrawTransaction pending 
  export const WithdrawTransactionPending = async (WithdrawPending) => {
    try {
      
      const response = await axiosInstance.post('/withdraw/pending', WithdrawPending);
      return response.data;
    } catch (error) {
      throw error;
    }
  };




//   export const FiatWithdraw = async (payload) => {
//   try {
//     // The leading slash is VERY important here
//     const response = await axiosInstance.post('/fiat/api/debit', payload);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

  // export const FiatWithdraw = async (FiatWithdraw) => {
  //   try {
      
  //     const response = await axiosInstance.post('/fiat/api/debit', FiatWithdraw);
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };



  export const FiatWithdraw = async (payload) => {
  try {
    // The leading slash is VERY important here
    const response = await axiosInstance.post('/fiat/api/debit', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};